import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "0555b829-7fb4-4839-9e1a-5c59bd969fcc",
    options: { imageUrl: `${config.ASSETS_URL}/01/12/task/task-2-item-1.svg` },
  },
  {
    id: "fcccee96-2628-441e-81bd-c8f562c0e206",
    options: { imageUrl: `${config.ASSETS_URL}/01/12/task/task-2-item-2.svg` },
  },
  {
    id: "16d644d5-5252-4b47-99cf-66ecbf61f366",
    options: { imageUrl: `${config.ASSETS_URL}/01/12/task/task-2-item-3.svg` },
  },
  {
    id: "9108b9b0-af37-48f9-a4ab-ccd230f17b84",
    options: { imageUrl: `${config.ASSETS_URL}/01/12/task/task-2-item-4.svg` },
  },
];

export const task: Task = {
  id: "d68bc83e-8d2a-4ebb-af03-637b4b73ab30",
  solutionType: "order",
  type: "orderImages",
  options: {
    shuffle: true,
    groupLabels: ["", "", "", ""],
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "fcccee96-2628-441e-81bd-c8f562c0e206",
    "16d644d5-5252-4b47-99cf-66ecbf61f366",
    "0555b829-7fb4-4839-9e1a-5c59bd969fcc",
    "9108b9b0-af37-48f9-a4ab-ccd230f17b84",
  ],
};
